import * as tslib_1 from "tslib";
import { GraphQueryableInstance, GraphQueryableCollection, defaultPath } from "./graphqueryable";
/**
 * Represents a Insights entity
 */
var Insights = /** @class */ (function (_super) {
    tslib_1.__extends(Insights, _super);
    function Insights() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(Insights.prototype, "trending", {
        get: function () {
            return new Trending(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Insights.prototype, "used", {
        get: function () {
            return new Used(this);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Insights.prototype, "shared", {
        get: function () {
            return new Shared(this);
        },
        enumerable: true,
        configurable: true
    });
    Insights = tslib_1.__decorate([
        defaultPath("insights")
    ], Insights);
    return Insights;
}(GraphQueryableInstance));
export { Insights };
/**
 * Describes a collection of Trending objects
 *
 */
var Trending = /** @class */ (function (_super) {
    tslib_1.__extends(Trending, _super);
    function Trending() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Trending = tslib_1.__decorate([
        defaultPath("trending")
    ], Trending);
    return Trending;
}(GraphQueryableCollection));
export { Trending };
/**
 * Describes a collection of Used objects
 *
 */
var Used = /** @class */ (function (_super) {
    tslib_1.__extends(Used, _super);
    function Used() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Used = tslib_1.__decorate([
        defaultPath("used")
    ], Used);
    return Used;
}(GraphQueryableCollection));
export { Used };
/**
 * Describes a collection of Shared objects
 *
 */
var Shared = /** @class */ (function (_super) {
    tslib_1.__extends(Shared, _super);
    function Shared() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Shared = tslib_1.__decorate([
        defaultPath("shared")
    ], Shared);
    return Shared;
}(GraphQueryableCollection));
export { Shared };
//# sourceMappingURL=insights.js.map